// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProfileRating_wrapper__qKACD","star":"ProfileRating_star__xlzBW","number":"ProfileRating_number__duWsK"};